import type { ComponentProps, ReactNode } from "react";
import { tv } from "tailwind-variants";

import { Message } from "@/domains/messages/components";
import type { MessageDataModel } from "@/domains/messages/models/types";
import { ProgressEntryLink } from "@/domains/progress/components";
import { useIsProgressEnabled } from "@/domains/progress/hooks/use-is-progress-enabled";
import { Heading } from "@/ui";

const yourCareplanHeaderMobileVariants = tv({
  base: "flex flex-col gap-7 bg-linear-to-b from-canvas-raised via-canvas-raised to-canvas px-5 pt-10 pb-14",
});

type YourCareplanHeaderMobileProps = {
  title: ReactNode;
  latestMessage: {
    message?: MessageDataModel;
    truncate: boolean;
  };
} & Omit<ComponentProps<"div">, "title">;

export const YourCareplanHeaderMobile = ({
  className,
  latestMessage,
  title,
}: YourCareplanHeaderMobileProps) => {
  const isProgressEnabled = useIsProgressEnabled();
  const showDetail = latestMessage.truncate && latestMessage.message?.exceedsTruncateLength;

  return (
    <div className={yourCareplanHeaderMobileVariants({ className })}>
      <div className="flex flex-col gap-3">
        <Heading level={1}>{title}</Heading>

        {isProgressEnabled ? <ProgressEntryLink /> : null}
      </div>

      {latestMessage.message ? (
        <Message.Root message={latestMessage.message} truncate={latestMessage.truncate}>
          <Message.Avatar />
          <div className="flex min-w-0 flex-1 flex-col items-start gap-2">
            {showDetail ? <Message.Detail /> : null}
            <Message.Bubble />
          </div>
        </Message.Root>
      ) : null}
    </div>
  );
};
